import { z } from "zod";
import { authenticationResponseJSONSchema } from "../schemas.js";

export default {
  params: z.object({
    accountId: z.string(),
    beneficiaryId: z.number(),
    amount: z.number(),
    beneficiaryValidationId: z.string(),
    label: z.string().optional(),
    reference: z.string().optional(),
    webAuthnAuthenticationResponse: authenticationResponseJSONSchema,
    transferRequestId: z.string().optional(),
  }),
  response: z.object({
    payoutId: z.number(),
  }),
};
